var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemVersionHistory = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20,
  fill: "none",
  viewBox: "0 0 22 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.398 18a8 8 0 0 1-2.232-.34l-.515 1.935c.71.209 1.453.34 2.22.387zm1.554 1.892c4.823-.713 8.526-4.87 8.526-9.892 0-5.522-4.478-10-10-10s-10 4.478-10 10H.401a.4.4 0 0 0-.35.593l2.073 3.77a.4.4 0 0 0 .7 0l2.074-3.77a.4.4 0 0 0-.35-.593h-1.07c0-4.41 3.59-8 8-8s8 3.59 8 8c0 3.704-2.53 6.828-5.952 7.735zM5.655 15.48l-.763 2.045c.58.507 1.218.949 1.903 1.313l.533-2a8 8 0 0 1-1.673-1.358M12.253 6v3.586l2.707 2.707a.999.999 0 1 1-1.414 1.414l-3.293-3.293V6a1 1 0 1 1 2 0",
  clipRule: "evenodd"
})));
export default SvgGemVersionHistory;